import { URLS } from '@wix/da-url';
import { PapiCustomboxTemplate } from '@wix/da-papi-types';

export const customBoxTemplates: PapiCustomboxTemplate[] = [
  {
    templateId: 1,
    position: 0,
    category: '',
    title: 'Empty Canvas',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_1.thumb.png`,
    backgroundImage: '',
    color: '',
    gradient: 0,
    imageTint: 'rgba(28,28,61,0.19)',
    imageDisplayMode: 'tile',
    backgroundType: 'image',
  },
  {
    templateId: 2,
    position: 0,
    category: '',
    title: 'Dawn Grid',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_2.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_2.jpg`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
  {
    templateId: 3,
    position: 0,
    category: '',
    title: 'Funky Fronds',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_3.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_3.jpg`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0.27)',
  },
  {
    templateId: 4,
    position: 0,
    category: '',
    title: 'Floral Breeze',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_4.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_4.gif`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
  {
    templateId: 5,
    position: 0,
    category: '',
    title: 'Marbleized',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_5.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_5.jpg`,
    backgroundType: 'image',
    color: '#F2F4E8',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(247,247,233,0)',
  },
  {
    templateId: 6,
    position: 0,
    category: '',
    title: 'Pixel Perfect',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_6.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_6.png`,
    backgroundType: 'image',
    color: '#F8F2F8',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(255,255,255,0)',
    pattern: `${URLS.CDN}/misc/custombox/patterns/pink-diamonds.png`,
  },
  {
    templateId: 7,
    position: 0,
    category: '',
    title: 'Stellar',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_7.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_7.png`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
  {
    templateId: 8,
    position: 0,
    category: '',
    title: 'Pastel Whimsy',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_8.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_8.png`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(222,129,104,0.49)',
  },
  {
    templateId: 9,
    position: 0,
    category: '',
    title: 'Twinkle',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_9.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_9.gif`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
  {
    templateId: 10,
    position: 0,
    category: '',
    title: 'Autumn Mist',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_10.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_10.jpg`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(229,229,223,0.86)',
  },
  {
    templateId: 11,
    position: 0,
    category: '',
    title: 'Gatsby Deco',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_11.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_11.png`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(1,6,38,0)',
  },
  {
    templateId: 12,
    position: 0,
    category: '',
    title: 'Arcade Invaders',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_12.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_12.gif`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6, 7, 13,0.14)',
  },
  {
    templateId: 13,
    position: 0,
    category: '',
    title: 'Haunted Graveyard',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_13.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_13.jpeg`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
  {
    templateId: 14,
    position: 0,
    category: '',
    title: 'Spooky Pumpkin',
    previewImage: `${URLS.CDN}/eclipse/widgets/custombox/template_14.thumb.png`,
    backgroundImage: `${URLS.CDN}/eclipse/widgets/custombox/template_14.jpeg`,
    backgroundType: 'image',
    color: '',
    gradient: 0,
    imageDisplayMode: 'tile',
    imageTint: 'rgba(6,7,13,0)',
  },
];
